import React from "react";

/**
 * Wenn gesetzt: Hintergrundfarbe für den Panel-Inhalt (z. B. FileTabs-Inhalt).
 * SectionCard und FloatingLabelInput nutzen diese Farbe, wenn sie in diesem Kontext gerendert werden.
 */
export const PanelContentBgContext = React.createContext<string | null>(null);

export function usePanelContentBg(): string | null {
  return React.useContext(PanelContentBgContext);
}
